import crud_actions from '../crud_actions'

export const registerWithEmail = crud_actions.read(
  'registerWithEmail',
  'registerWithEmail'
)
// load the user info back into the same place as registering would put it,
// to allow for reloads on the pin confirmation page
export const loadUserByUsername = crud_actions.read(
  'registerWithEmail',
  'loadUserByUsername'
)
export const confirmWithPin = crud_actions.read(
  'confirmEmailWithPin',
  'confirmEmailWithPin'
)
export const confirmWithToken = crud_actions.read(
  'confirmEmailWithToken',
  'confirmEmailWithToken'
)
